import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const BASE    = "/api/kokam";

const authHeaders = (token) => ({
  headers:         { Authorization: `Bearer ${token}` },
  withCredentials: true,
});

export const postDescargarDocumentos = async (identificaciones, idEncuesta, token) => {
  try {
    const response = await axios.post(
      `${baseUrl}${BASE}/descargar-documentosEntregas`,
      { identificaciones, idEncuesta },
      authHeaders(token)
    );
    return response.data;
  } catch (error) {
    console.error("Error en descargar documentos:", error);
    throw error;
  }
};

export const getValidaciones = async (token) => {
  try {
    const response = await axios.get(
      `${baseUrl}${BASE}/validacionesEntregas`,
      authHeaders(token)
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo validaciones:", error);
    throw error;
  }
};

export const patchEstado = async (identificacion, estado, token) => {
  try {
    const response = await axios.patch(
      `${baseUrl}${BASE}/validacionesEntregas/${identificacion}/estado`,
      { estado },
      authHeaders(token)
    );
    return response.data;
  } catch (error) {
    console.error("Error actualizando estado:", error);
    throw error;
  }
};